import { useEffect, FC } from 'react';
import { useNavigate } from 'react-router';

import { Notification } from 'types/notification';
import {
  useCustomerStore,
  useEditStore,
  useListStore,
} from 'page/NotificationPage/hooks';
import { NotificationListView } from 'page/NotificationPage/components/NotificationListView';
import { APP_ROUTES } from 'constants/appRoutes';

export const NotificationList: FC = () => {
  const navigate = useNavigate();
  const {
    loading,
    currentPage,
    lastPage,
    notifications,
    selectedNotification,
    selectNotification,
  } = useListStore();
  const { openModal, setCondition } = useEditStore();
  const { fetchCustomersAndSelectTargets } = useCustomerStore();

  /**
   * お知らせの行をクリックしたときの処理
   * @param notification クリックされたお知らせ
   */
  const handleClickNotification = (notification: Notification) => {
    selectNotification(notification);
  };

  /**
   * お知らせが選択されたときの処理
   */
  useEffect(() => {
    if (!selectedNotification) {
      return;
    }
    void fetchCustomersAndSelectTargets();
    setCondition(selectedNotification.condition);
    openModal();
  }, [
    selectedNotification,
    fetchCustomersAndSelectTargets,
    setCondition,
    openModal,
  ]);

  /**
   * ぺージングのページ変更時の処理
   * @param page クリックされたページ番号
   */
  const handlePageChange = (page: number) => {
    navigate(`${APP_ROUTES.NOTIFICATION}?page=${page}`, { replace: false });
  };

  return (
    <NotificationListView
      loading={loading}
      currentPage={currentPage}
      lastPage={lastPage}
      notifications={notifications}
      handlePageChange={handlePageChange}
      handleClickNotification={handleClickNotification}
    />
  );
};
